export enum NativeAppMessage {
  DID_FINISH_LOADING = 'DID_FINISH_LOADING',
  LINK_CLICKED = 'LINK_CLICKED',
  OPEN_EXTERNAL_URL = 'OPEN_EXTERNAL_URL',
  OPEN_DOWNLOAD_URL = 'OPEN_DOWNLOAD_URL',
  LOGGED_OUT = 'LOGGED_OUT',
  PHONE_CLICKED = 'PHONE_CLICKED',
  MAILTO_CLICKED = 'MAILTO_CLICKED',
  DISMISS_NAVIGATION_STACK = 'DISMISS_NAVIGATION_STACK',
}

export function sendNativeAppMessage(message: NativeAppMessage, data?: any) {
  if (
    window &&
    (window as any)?.webkit &&
    (window as any)?.webkit.messageHandlers &&
    (window as any)?.webkit.messageHandlers.nativeApp
  ) {
    (window as any).webkit.messageHandlers.nativeApp.postMessage(
      JSON.stringify({
        message,
        data,
      }),
    );
  }
}
